// extracted by mini-css-extract-plugin
export default {"btnDemo":"oAnDHFJwQtVyH4TJ6o0I","containerDemo":"aaiIlsRErUbP5qi80Qdf","accounts":"V5lp5JqD2ah3VibPP36c","demoIsLoading":"fGITp79ZaxdEApLxWfw_","launch":"MeURh3iZjz2Hji_IYydl"};